import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

// Hero parallax fade on scroll — desktop only
(function () {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  if (window.innerWidth < 769 || prefersReducedMotion) return;

  const hero = document.querySelector("#hero .container");
  if (!hero) return;

  let ticking = false;

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.scrollY;
          const opacity = 1 - scrollY / 600;
          const translateY = scrollY * 0.3;

          hero.style.opacity = Math.max(opacity, 0);
          hero.style.transform = "translateY(" + translateY + "px)";
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true }
  );
})();
